<template>
  <div class="card card-custom card-stretch gutter-b">
    <!--begin::Body-->
    <div class="card-body d-flex flex-column">
      <div class="flex-grow-1 pb-5">
        <!--begin::Info-->
        <h1 style="text-transform: uppercase">
          Rechnungsjournal
        </h1>
        <div class="d-flex align-items-center mb-6">
          <span class="text-muted font-weight-bold font-size-lg flex-grow-1">
            Filtern Sie die gewünschten Daten. Anschließend können Sie diese herunterladen.</span
          >
          <!--          <div class="symbol symbol-50">
            <span class="symbol-label bg-light-light">
              <img
                src="media/svg/icons/Home/Timer.svg"
                class="h-50 align-self-center"
                alt=""
              />
            </span>
          </div>-->
        </div>
        <!--end::Info-->

        <div class="vld-parent">
          <loading
              :active.sync="isLoading"
              :can-cancel="true"
              :is-full-page="true"
          ></loading>
        </div>

        <v-app>
          <v-container>
            <v-row class="mt-4" align="center" wrap>
              <v-col cols="12" sm="6" md="4">
                <v-menu
                  ref="menu"
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateRangeText"
                      class="mt-5"
                      label="Datum auswählen"
                      prepend-icon="mdi-calendar"
                      readonly
                      dense
                      filled
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dateRange"
                    type="date"
                    range
                    locale="de"
                    first-day-of-week="1"
                    @change="dateMenu = false"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text @click="dateMenu = false">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-chip-group
                  v-model="statusFilter"
                  row
                  mandatory
                  color="primary"
                >
                  <v-chip value="" outlined>Alle</v-chip>
                  <v-chip value="offen" outlined>Offen</v-chip>
                  <v-chip value="bezahlt" outlined>Bezahlt</v-chip>
                </v-chip-group>
              </v-col>
              <v-col cols="12" sm="12" md="4" class="d-flex justify-end">
                <v-btn
                    class="secondary custom_button"
                    large
                    height="50"
                    outlined
                    @click="clearFilters"
                >
                  <v-icon left>mdi-filter-remove</v-icon>
                  Filter zurücksetzen
                </v-btn>
                <v-btn
                  class="primary custom_button"
                  large
                  height="50"
                  style="margin-left: 15px;"
                  :disabled="filteredDocuments.length === 0"
                  @click="exportToCsv"
                >
                  <v-icon left>mdi-download</v-icon>
                  Rechnungsjournal Download
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-data-table
                    :headers="headers"
                    :items="filteredDocuments"
                    :items-per-page="30"
                    sort-by="invoice_number"
                    sort-desc
                    class="table1"
                    :loading="loadingvariable"
                    loading-text="Bitte warten... Dokumente werden geladen"
                >
                  <template v-slot:footer.page-text="items">
                    {{ items.pageStart }} von {{ items.itemsLength }}
                  </template>
                  <template v-slot:item.documents_type_id="{ item }">
                    <v-chip
                        style="font-size: 12px"
                        color="secondary"
                        :text-color="
                        item.documents_type_id !== 3 ? 'primary' : 'red'
                      "
                    >
                      {{ getDocumentType(item.documents_type_id) }}
                    </v-chip>
                  </template>
                  <template v-slot:item.total="{ item }">
                    {{ formatCurrency(item.total) }}
                  </template>
                  <template v-slot:item.status="{ item }">
                    <div style="display: flex; flex-direction: column; align-items: center;">
                      <div>{{ $t("OVERVIEW." + item.status) }}</div>
                    </div>
                  </template>
                  <template v-slot:item.is_paid="{ item }">
                    <div style="display: flex; flex-direction: column; align-items: center;">
                      <v-chip
                          small
                          :color="item.is_paid ? 'green lighten-2' : 'grey lighten-2'"
                          :text-color="item.is_paid ? 'white' : 'grey darken-2'"
                          class="mt-1"
                          :outlined="!item.is_paid"
                          :disabled="item.documents_type_id === 3"
                          style="border-radius: 50px; min-width: 60px; justify-content: center; text-align: center;"
                      >
                        {{ item.is_paid ? 'Bezahlt' : (item.documents_type_id === 3 ? '-' : 'Offen') }}
                      </v-chip>
                    </div>
                  </template>
                  <template v-slot:item.change_status="{ item }">
                    <div class="d-flex justify-center mb-4">
                      <v-switch
                        v-model="item.is_paid"
                        hide-details
                        @change="updatePaidStatus(item)"
                      ></v-switch>
                    </div>
                  </template>
                  <template v-slot:item.auto_generated="{ item }">
                    <div v-if="item.auto_generated === 1">
                      <v-chip
                          style="font-size: 12px"
                          color="secondary"
                          :text-color="
                        item.auto_generated !== 0 ? 'primary' : 'black'
                      "
                      >
                        {{ item.auto_generated === 1 ? "JA" : "NEIN" }}
                      </v-chip>
                    </div>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-tooltip v-if="currentUser.admin === 1" top attach="" dense color="primary">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            small
                            class="mr-2"
                            @click="toInvoiceWithHash(item)"
                            text="test"
                            style="font-size: 20px;"
                            v-bind="attrs"
                            v-on="on"
                        >
                          mdi-magnify
                        </v-icon>
                      </template>
                      <span>Öffne Dokument</span>
                    </v-tooltip>
                    <v-tooltip v-if="currentUser.admin === 1" top attach="" dense color="primary">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            v-if="
                            item.status === document_status_types.STATUS_DRAFT
                          "
                            small
                            :disabled="item.edited !== 0"
                            class="mr-2"
                            @click="deleteDocument(item)"
                            text="test"
                            style="font-size: 20px;"
                            v-bind="attrs"
                            v-on="on"
                        >
                          mdi-delete
                        </v-icon>
                      </template>
                      <span>Lösche Dokument</span>
                    </v-tooltip>
                    <v-tooltip top attach="" dense color="primary">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            v-if="
                            item.status !== document_status_types.STATUS_DRAFT
                          "
                            small
                            class="mr-2"
                            @click="getPdf(item)"
                            style="font-size: 18px;"
                            color="brown"
                            v-bind="attrs"
                            v-on="on"
                        >
                          mdi-file-pdf
                        </v-icon>
                      </template>
                      <span>PDF Download</span>
                    </v-tooltip>
                    <v-tooltip v-if="currentUser.admin === 1" top attach="" dense color="primary">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            v-if="
                            item.status !==
                              document_status_types.STATUS_DRAFT &&
                              !item.reference_number
                          "
                            small
                            class="mr-2"
                            @click="createCancellation(item.unique_hash)"
                            style="font-size: 18px;"
                            v-bind="attrs"
                            v-on="on"
                        >
                          mdi-file-document-box-remove
                        </v-icon>
                      </template>
                      <span>Rechnung stornieren</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:no-data>
                    <div v-if="(dateRange && dateRange.length) || statusFilter">
                      Es konnten keine Dokumente gefunden werden. Bitte prüfen Sie Ihre Filtereinstellungen oder setzen Sie hier
                      <a href="#" @click.prevent="clearFilters">den Filter zurück</a>.
                    </div>
                    <div v-else>
                      Es sind keine Dokumente vorhanden.
                    </div>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-app>
      </div>
    </div>
  </div>
</template>
<style>
.v-data-footer__select {
  display: none !important;
}

.custom_button.theme--light.v-btn.v-btn--disabled {
  background-color: lightgray !important;
}
/* Sortierpfeile immer anzeigen für alle Spalten */
.v-data-table-header th .v-data-table-header__icon {
  opacity: 1 !important;
}

/* Optional: nur bestimmte Spalten gezielt ansprechen */
.v-data-table-header th[data-test-id="force-visible"] .v-data-table-header__icon {
  opacity: 1 !important;
}
</style>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ApiService from "@/core/services/api.service";
import { LOGOUT } from "@/core/services/store/auth.module";
import DocumentType from "@/stub/doctype";
import DocumentStatusTypes from "@/stub/statustypes";
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import VTooltip from "v-tooltip";
import Vue from "vue";
import {getUserProfile} from "@/core/services/store/auth.module";

Vue.use(VTooltip);

export default {
  name: "overview",
  components: { Loading },
  data: function() {
    return {
      pageTitle: "documents Overview",
      selectedCompany: null,
      selectedClient: null,
      loadingvariable: false,
      currentUser: null,
      headers: [
        { text: this.$t("OVERVIEW.Type"), value: "documents_type_id", align: "center", sortable: false },
        { text: this.$t("OVERVIEW.Number"), value: "invoice_number", align: "center" },
        { text: this.$t("OVERVIEW.Date"), value: "invoice_date", align: "center" },
        { text: this.$t("OVERVIEW.Client"), value: "client.CompanyName", sortable: false},
        { text: 'Rechnungssumme', value: "total", sortable: true},
        { text: this.$t("OVERVIEW.Paid"), value: "is_paid",  align: "center"  },
        { text: 'Status ändern', value: 'change_status', align: 'center', sortable: false },
      ],
      documents: {},
      document_type_id: {
        ...DocumentType
      },
      document_status_types: {
        ...DocumentStatusTypes
      },
      copyInvoiceTemp: {},
      openCopyInvoiceDialog: false,
      openCopyInvoiceToClientDialog: false,
      company_clients: [],
      isLoading: false,
      dateMenu: false,
      dateRange: [],
      statusFilter: '',
    };
  },

  computed: {
    filteredDocuments() {
      return this.documents.filter(doc => {
        // Date filter
        let matchesDate = true;
        if (this.dateRange.length === 2) {
          const [start, end] = this.dateRange;
          matchesDate = doc.invoice_date >= start && doc.invoice_date <= end;
        }
        // Status filter
        let matchesStatus = true;
        if (this.statusFilter === 'offen') {
          matchesStatus = !doc.is_paid && doc.documents_type_id !== this.document_status_types.STATUS_STORNO;
        } else if (this.statusFilter === 'bezahlt') {
          matchesStatus = doc.is_paid;
        }
        return matchesDate && matchesStatus;
      });
    },
    dateRangeText() {
      if (this.dateRange.length === 2) {
        return `${this.dateRange[0]} – ${this.dateRange[1]}`;
      }
      return '';
    }
  },
  created() {
    this.documents = [];
    this.loadingvariable = true;
    this.getInvoices();
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Overview" }]);

    this.currentUser = getUserProfile();
    this.currentUser = JSON.parse(this.currentUser);
  },
  watch: {
    /*selectedCompany(company) {
      this.selectedCompanyCopy = Object.assign({}, this.selectedCompany);

      if (company) {
        this.loadingvariable = true;
        this.getInvoices(company.CompanyId);
      }
    }*/
    selectedClient(client) {
      //this.selectedClient = Object.assign({}, this.selectedClient);

      if (client) {
        this.loadingvariable = true;
        this.getInvoices(client.id);
      }
    }
  },
  methods: {
    clearAutocomplete(){
      if (!this.selectedClient)
        this.getLastInvoices();
    },
    getDocumentType(documents_type_id) {
      switch (documents_type_id) {
        case 1:
          return "RECHNUNG";
        case 2:
          return "GUTSCHRIFT";
        case 3:
          return "STORNIERUNG";
        default:
          return "-";
      }
    },
    createCancellation(unique_hash) {
      Swal.fire({
        title: "Stornierung erstellen",
        text: "Möchten Sie diese Rechnung wirklich stornieren?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ja",
        cancelButtonText: "Abbrechen"
      }).then(invoice => {
        if (invoice.value) {
          this.isLoading = true;
          ApiService.post("invoice/cancellation", {
            unique_hash: unique_hash
          })
              .then(() => {
                location.reload();
              })
              .catch(({ response }) => {
                if (response.status === 401) {
                  this.$store
                      .dispatch(LOGOUT)
                      .then(() => this.$router.push({ name: "login" }));
                } else {
                  Swal.fire({
                    title: response.status+" Fehler bei der Stornierung",
                    text: response.data.message,
                    icon: "error",
                    confirmButtonText: "Ok"
                  });
                }
                this.isLoading = false;
              });
        }
      });
    },
    getPdf(item) {
      this.isLoading = true;
      ApiService.getFile("/invoice/pdf", item.unique_hash)
          .then(response => {
            this.isLoading = false;
            const blobUrl = window.URL.createObjectURL(
                new Blob([response.data], { type: "application/pdf" })
            );
            const link = document.createElement("a");
            link.href = blobUrl;
            link.setAttribute("download", item.invoice_number);
            link.click();
            link.remove();
            URL.revokeObjectURL(blobUrl);
          })
          .catch(({ response }) => {
            if (response.status === 401) {
              if (response.status === 401) {
                this.$store
                    .dispatch(LOGOUT)
                    .then(() => this.$router.push({ name: "login" }));
              }
            }
          });
    },
    toInvoice(document_type_id) {
      //this.$router.push("/dashboard/schedules");

      this.$router.push({
        name: "invoice",
        query: { type: document_type_id },
        params: { company: this.selectedCompany },
        pathToRegexpOptions: { strict: true }
      });
    },

    deleteDocument(item) {
      Swal.fire({
        title: "Dokument löschen",
        text: "Möchten Sie dieses Dokument wirklich löschen?",
        icon: "warning",
        timerProgressBar: true,
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        confirmButtonText: "Löschen",
        cancelButtonText: "Abbrechen"
      }).then(result => {
        if (result.value) {
          this.isLoading = true;
          ApiService.post("/invoice/delete/" + item.unique_hash)
              .then(({ data }) => {
                this.isLoading = false;
                let index = this.documents.indexOf(item);
                this.documents.splice(index, 1);
                Swal.fire("", data.message, "success");
              })
              .catch(({ response }) => {
                if (response.status === 403) {
                  Swal.fire("", response.data.message, "error");
                }
                if (response.status === 401) {
                  if (response.status === 401) {
                    this.$store
                        .dispatch(LOGOUT)
                        .then(() => this.$router.push({ name: "login" }));
                  }
                }
                this.isLoading = false;
              });
        }
      });
    },
    toInvoiceWithHash(item) {
      //this.$router.push("/dashboard/schedules");
      this.$router.push({
        name: item.unique_hash ? "invoice-hash" : "invoice",
        params: { hash: item.unique_hash },
        pathToRegexpOptions: { strict: true }
      });
    },
    getInvoices() {
      this.loadingvariable = true;
      ApiService.query("/journal")
          .then(({ data }) => {
            this.documents = data.invoices;
            this.loadingvariable = false;
          })
          .catch(({ response }) => {
            if (response.status === 401) {
              if (response.status === 401) {
                this.loadingvariable = false;
                this.$store
                    .dispatch(LOGOUT)
                    .then(() => this.$router.push({ name: "login" }));
              }
            }
          });
    },
    closeCopyInvoices() {
      this.openCopyInvoiceDialog = false;
    },
    getHeaders(headingText) {
      return [
        {
          text: "Dynamic heading no. " + headingText,
          align: "left",
          sortable: false,
          value: "name"
        }
      ];
    },
    setActiveTab1(event) {
      this.tabIndex = this.setActiveTab(event);
    },
    setActiveTab2(event) {
      this.tabIndex2 = this.setActiveTab(event);
    },
    /**
     * Set current active on click
     * @param event
     */
    setActiveTab(event) {
      // get all tab links
      const tab = event.target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".nav-link");
      // remove active tab links
      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      // set current active tab
      event.target.classList.add("active");

      // set clicked tab index to bootstrap tab
      return parseInt(event.target.getAttribute("data-tab"));
    },
    clearFilters() {
      this.statusFilter = '';
      this.dateRange = [];
    },
    formatCurrency(value) {
      // Convert cents to euros and format with two decimals, comma separator, and euro sign
      const euros = Number(value) / 100;
      return euros
        .toFixed(2)
        .replace('.', ',') + ' €';
    },
    exportToCsv() {
      // UTF-8 BOM definieren
      const BOM = '\uFEFF';
      // CSV-Header und Zeilen vorbereiten
      const header = ['Rechnungsnummer','Datum','Kunde','Rechnungssumme','Zahlung'];
      const rows = this.filteredDocuments.map(item => [
        item.invoice_number,
        item.invoice_date,
        item.client.CompanyName,
        this.formatCurrency(item.total),
        item.is_paid ? 'Bezahlt' : 'Offen'
      ]);
      // Jede Zelle in doppelte Anführungszeichen einschließen
      const csvLines = [header, ...rows]
        .map(row => row.map(cell => `"${cell}"`).join(';'));
      const csvContent = BOM + csvLines.join('\n');
      // Blob erstellen und Download auslösen
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      // Build dynamic filename with status and optional date filter
      const statusLabel = this.statusFilter || 'alle';
      let filename = `rechnungsjournal_${statusLabel}`;
      if (this.dateRange.length === 2) {
        const [start, end] = this.dateRange;
        filename += `_${start.replace(/\./g, '')}-${end.replace(/\./g, '')}`;
      }
      filename += '.csv';
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async updatePaidStatus(item) {
      this.isLoading = true;
      try {
        await ApiService.post(`invoice/paid/${item.id}/status`, {
          is_paid: item.is_paid ? 1 : 0
        });
        // Optional: Erfolgsmeldung anzeigen
      } catch ({ response }) {
        if (response.status === 401) {
          await this.$store.dispatch(LOGOUT);
          this.$router.push({ name: 'login' });
        } else {
          Swal.fire('Fehler', response.data.message, 'error');
        }
      } finally {
        this.isLoading = false;
      }
    },
  }
};
</script>
